module.exports = __webpack_public_path__ + "img/kvinta_ru.6bbbf592.svg";